<template>
  <!-- eslint-disable -->
<v-container fluid>
  <v-slide-y-transition mode="out-in">
    <div>
      <v-speed-dial v-model="fab" right top fixed direction="bottom" transition="slide-y-reverse-transition">
        <template v-slot:activator>
          <v-btn class="refresh-btn" v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab">close</v-icon>
            <v-icon v-else>account_circle</v-icon>
          </v-btn>
        </template>
        <v-btn fab dark small class="add-user-btn" color="indigo" @click="add()">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn fab class="refresh-clients-btn" dark small color="red" @click="loadClients()">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-speed-dial>
      <div style="padding-bottom: 15px;">
        <v-text-field class="user-filter" slot="search" prepend-icon="search" :append-icon="search == null || search.length === 0 ? '' : 'clear'" @click:append="() => (search = null)" label="Search" single-line hide-details v-model="search"></v-text-field>
      </div>
      <v-data-table :mobile-breakpoint="0" class="clients-data-table" hide-default-footer disable-pagination :items="filteredClients" item-key="UserName" :headers="headers" :loading="loadingClients">
        <template slot="no-data">
          <div v-if="loadingClients" class="text-xs-center clients-loading">
            Loading Clients. . .
          </div>
          <div v-else class="text-xs-center no-clients">
            No Clients.
          </div>
        </template>
        <template v-slot:item="{ item }">
          <tr class="user-row" v-on:mouseenter="clientHover(item, true)" v-on:mouseleave="clientHover(item, false)" @click="edit(item.Id)">
            <td>
              <v-list-item-action avatar style="float: left">
                <v-avatar class="user-avatar" :class="getColor(item.Id)" v-if="!item.hover">
                <span class="white--text headline">{{item.Name.match(/\b(\w)/g)[0].toUpperCase()}}</span>
                </v-avatar>
                <div v-else class="edit-icon" style="position: relative; top: 5px; left: 15px;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" @click="edit(item.Id)" small>mode_edit</v-icon>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                </div>
              </v-list-item-action>
              <div style="padding: 20px 0 20px 75px;"><b>{{ item.Name }}</b></div>
            </td>
            <td>
              <v-icon :style="{'color': item.IsActive ? 'green' : 'red'}">fiber_manual_record</v-icon>
              <span>{{item.IsActive ? 'Active' : 'Inactive'}}</span>
            </td>
            <td style="text-align: right; min-width: 75px;">
              <v-icon v-if="item.hover">create</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <ClientSettingsDialog/>
      <v-progress-circular :size="55" :width="5" indeterminate color="primary" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);" v-if="loadingClientDetail" />
      </div>
    </v-slide-y-transition>
  </v-container>
  <!-- eslint-enable -->
</template>
<script>
import clientSettingsModule, {
  CLIENT_SETTINGS_NAMESPACE
} from "./../store/clientSettingsStore";
import { mapGetters } from "vuex";
import ClientSettingsDialog from "./ClientSettingsDialog";
export default {
  name: "ClientSettings",
  components: {
    ClientSettingsDialog
  },
  data() {
    return {
      fab: false,
      search: null,
      colors: [
        "red",
        "indigo",
        "green",
        "blue",
        "purple",
        "cyan",
        "teal",
        "brown",
        "lime",
        "yellow",
        "pink",
        "blue-grey",
        "orange"
      ],
      headers: [
        {
          align: "left",
          sortable: true,
          text: "Client",
          value: "Name"
        },
        {
          align: "left",
          sortable: true,
          text: "Is Active",
          value: "IsActive"
        },
        {
          sortable: false,
          text: ""
        }
      ],
      selected: false
    };
  },
  computed: {
    ...mapGetters(CLIENT_SETTINGS_NAMESPACE, [
      "clients",
      "loadingClients",
      "loadingClientDetail"
    ]),
    filteredClients() {
      if (this.search) {
        return this.clients.filter(x =>
          x.Name.toLowerCase().includes(this.search.toLowerCase())
        );
      }
      return this.clients;
    }
  },
  created() {
    this.$registerVuexModule(CLIENT_SETTINGS_NAMESPACE, clientSettingsModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.BETA_FEATURE]).then(
      res => {
        if (res) {
          this.loadClients();
          this.loadOptionsList();
          this.loadBillingStructures();
          this.loadBillingLineItems();
          this.loadScriptTypes();
        } else this.$goHome();
      }
    );
  },
  methods: {
    clientHover(client, hover) {
      client.hover = hover;
      this.$forceUpdate();
    },
    getColor(clientId) {
      return this.colors[clientId % 13];
    },
    loadClients() {
      this.$store.dispatch(`${CLIENT_SETTINGS_NAMESPACE}/loadClients`);
    },
    loadBillingStructures() {
      this.$store.dispatch(
        `${CLIENT_SETTINGS_NAMESPACE}/loadBillingStructures`
      );
    },
    loadScriptTypes() {
      this.$store.dispatch(`${CLIENT_SETTINGS_NAMESPACE}/loadScriptTypes`);
    },
    loadBillingLineItems() {
      this.$store.dispatch(`${CLIENT_SETTINGS_NAMESPACE}/loadBillingLineItems`);
    },
    loadOptionsList() {
      return this.$store.dispatch(
        `${CLIENT_SETTINGS_NAMESPACE}/loadOptionsList`
      );
    },
    edit(clientId) {
      this.$store
        .dispatch(`${CLIENT_SETTINGS_NAMESPACE}/loadClientDetails`, clientId)
        .then(res => {
          this.$emit("clientEdit");
        });
    },
    add() {
      this.$store
        .dispatch(`${CLIENT_SETTINGS_NAMESPACE}/selectClient`, null)
        .then(res => {
          this.$emit("clientEdit", 1);
        });
    }
  }
};
</script>
